// import Vue from 'vue';
import ContractsService from '@/services/API/ContractsService';
import PaymentModal from '@/modules/PaymentSystem/components/PaymentModal.vue';
import DiscountModal from '@/modules/PaymentSystem/components/DiscountModal.vue';

import store from '@/store';
import { modalsController } from '@/plugins/modals';

export default class Contracts {
  constructor({
    id,
    sum,
    users,
    number,
    document,
    owner_id: ownerId,
    is_active: isActive,
    sum_total: totalSum,
    sum_discount: sumDiscount,
    prior_record_id: priorRecordId,
    typical_contract: typicalContract,
    typical_contract_id: typicalContractId,
    typical_contract_discount: typicalContractDiscount,
    preview_document: previewDocument,
    listener_preview_document: listenerPreviewDocument,
    is_viewed: isViewed,
    is_concluded: isConcluded,
    transactions,
    date_at: dateAt,
    is_signed_customer: isSignedCustomer,
    is_signed_executor: isSignedExecutor,
  }) {
    this.id = id;
    this.sum = sum;
    this.users = users;
    this.qr_code = null;
    this.number = number;
    this.owner_id = ownerId;
    this.is_active = isActive;
    this.sum_total = totalSum;
    this.sum_discount = sumDiscount;
    this.prior_record_id = priorRecordId;
    this.typical_contract = typicalContract;
    this.typical_contract_id = typicalContractId;
    this.typical_contract_discount = typicalContractDiscount;
    this.openPaymentPDF = this.openPaymentPDF.bind(this);
    this.isMyEnrollment = this.getMyEnroll();
    this.payment_url = null;
    this.paymentMessage = null;
    this.getQr = this.getQr.bind(this);
    this.transactions = (transactions || []).map((i) => ({ ...i, sum: (i.sum / 100) }));
    this.preview_document = previewDocument;
    this.listener_preview_document = listenerPreviewDocument;
    this.is_viewed = isViewed || false;
    this.is_concluded = isConcluded;
    this.date_at = dateAt;
    this.document = document;
    this.is_signed_customer = isSignedCustomer;
    this.is_signed_executor = isSignedExecutor;
    // this.getPayments();
  }

  get sumWhitoutDiscount() {
    if (+this.sum_discount) return this.sum;
    if (this.typical_contract_discount) {
      return (this.sum_total / (100 - this.typical_contract_discount.percent)) * 100;
    }
    return null;
  }

  get userViewContract() {
    const userId = store.getters['auth/userData'].id;
    return this.users.find(({ id }) => id === userId).is_viewed;
  }

  get paymentPercent() {
    return Math.ceil((this.payment / +this.sum_total) * 100);
  }

  get isPaymentPrePayment() {
    return this.paymentPercent >= this.typical_contract.prepayment_percent;
  }

  get prePaymentValue() {
    return +this.sum_total * (this.typical_contract.prepayment_percent / 100);
  }

  get isAllPayed() {
    return this.payment >= +this.sum_total;
  }

  get payment() {
    let result = 0;
    this.transactions.forEach((i) => {
      result += i.sum;
    });
    return result;
  }

  get maxPayment() {
    return this.sum_total - this.payment;
  }

  openPaymentModal(isEnrollment) {
    modalsController.show('generic-controller', {
      title: 'Оплата по договору',
      component: PaymentModal,
      dialogProps: {
        width: 800,
      },
      'component-props': {
        paymentValue: this.isPaymentPrePayment ? this.maxPayment : this.prePaymentValue,
        contract: this,
        needToPay: isEnrollment,
      },
    });
  }

  openDiscountModal() {
    modalsController.show('generic-controller', {
      title: 'Установите сумму скидки',
      component: DiscountModal,
      dialogProps: {
        width: 800,
      },
      'component-props': {
        saveMethod: (val) => this.setDiscount(val),
      },
    });
  }

  async setDiscount(discount) {
    const payload = { sum_discount: discount };
    await ContractsService.setContractDiscount(this.id, payload)
      .then(({ data }) => {
        this.sum_total = data.data.sum_total;
        this.sum_discount = data.data.sum_discount;
        modalsController.close();
      });
  }

  async setPayment(val) {
    const payload = {
      sum: val,
      contract_id: this.id,
    };
    await ContractsService.setPayment(payload)
      .then(({ data }) => this.transactions.push({
        ...data.data,
        sum: Number(data.data.sum),
      }));
    modalsController.close();
  }

  getQr(val) {
    const sum = Number(val).toFixed(2);
    ContractsService.getQR(this.id, { sum })
      .then((data) => { this.qr_code = data.data; });
  }

  startPaymentWithQr(val) {
    const amount = Number((val * 100).toFixed(0));
    ContractsService.startPaymentWithQr(this.id, { amount })
      .then(({ data }) => {
        this.qr_code = data.data.qr_spb;
        this.payment_url = data.data.payment_url;
        this.paymentMessage = data.data.message;
      });
  }

  getPayments() {
    const params = {
      'search[contract_id': this.id,
    };
    ContractsService.getPayments(params)
      .then(({ data }) => {
        this.transactions = data.data;
      });
  }

  openPaymentPDF(val) {
    const sum = Number(val).toFixed(2);
    ContractsService.getPDF(this.id, { sum })
      .then((data) => {
        const blob = new Blob([data.data], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl);
      });
    modalsController.close();
  }

  async viewContract() {
    await ContractsService.viewContract(this.id).then(() => {
      this.is_viewed = true;
    });
  }

  getMyEnroll() {
    return this.owner_id === store.getters['auth/userData'].id;
  }
}
